module.exports = __webpack_public_path__ + "static/jccfc-c7ed11fccd474785ac514d05a4cdf990.jpg";